<template>
  <div class="dacb-chat-window" :data-name-form="!customer.name" :data-field-count="formFields.length">
    <chat-header />

    <message-list v-if="customer.name" />

    <div v-if="customer.name" class="dacb-reply-box-wrapper">
      <reply-form v-if="formFields.length" :fields="formFields" :data="formData" />
      <reply-box v-else />
    </div>
    <div v-else class="dacb-message-list">
      <message-list />
      <name-form />
    </div>

    <div class="dacb-powered-by">
      <a href="https://ripley.chat" target="_blank">
        {{ $t("poweredBy") }} <em :style="{ color: options.primaryColour }">{{ $t("ripley") }}</em>
      </a>
    </div>
  </div>
</template>

<script>
import ChatHeader from "components/ChatHeader.vue";
import MessageList from "components/MessageList.vue";
import NameForm from "components/NameForm.vue";
import ReplyBox from "components/ReplyBox.vue";
import ReplyForm from "components/ReplyForm.vue";
import { mapState } from "vuex";

export default {
  name: "ChatWindow",

  components: { ChatHeader, MessageList, ReplyBox, ReplyForm, NameForm },

  computed: {
    ...mapState({
      customer: (state) => state.customer.current,
      conversation: (state) => state.conversation.current,
      formFields: (state) => state.messages.formFields,
      formData: (state) => state.messages.formData,
      options: (state) => state.options.options
    })
  }
};
</script>
